// extracted by mini-css-extract-plugin
module.exports = {"EledoCreateRoot":"EledoCreateRoot_EledoCreateRoot__IUMPj","content-wrapper":"EledoCreateRoot_content-wrapper__2gBxW"};